export const SHOW_MODAL = '@UI/MODAL/SHOW_MODAL';
export const HIDE_MODAL = '@UI/MODAL/HIDE_MODAL';

export const CREATE_DIRECTORY_MODAL_ID = 'CREATE_DIRECTORY_MODAL';
export const BASKET_VIEW_MODAL_ID = 'BASKET_VIEW_MODAL';
